/* Editor chrome shared by every FormaDock workspace (Designer, Forma Studio,
   Spec Studio, Module Builder): where the dock is, and what a floating
   panel is. Nothing forma- or document-specific lives here. */

/**
 * Is this screen point inside the dock — i.e. would letting go here DOCK the
 * panel rather than float it?
 *
 * §2.8's rule is spatial ("release outside every dock zone to leave it as a
 * floating box"), so the answer is geometry, not a guess about whether some
 * drop handler fired. The dockview body IS the dock zone; the header, the
 * toolbar and everything beyond the workspace are not.
 */
export function isOverDockZone(x: number, y: number): boolean {
  const el = document.querySelector('.dsg-workspace .forma-dock-body');
  const r = el?.getBoundingClientRect();
  if (!r) return false;
  return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
}

/** A panel the user opened without docking it. */
export interface FloatingTool {
  id: string;
  /** Where a drag-to-float released it, when that is how it got here. */
  at?: { left: number; top: number } | null;
}
